import React from 'react'
import about01 from '../../images/about-slider01.png'
import about02 from '../../images/about-slider02.png'
import about03 from '../../images/about-slider03.png'
import bg_slider from '../../images/bg-about.png'
export default function AboutSlider() {
  return (
    <div className='black-img-bg'>
        <div className='row align-items-center'>
            <div className='col-md-6 about-slider-padding'>
                <div className='bg-slider'>
                    <img src={bg_slider} />
                </div>
                <div id="carouselExampleCaptions" className="carousel slide about-slider" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={about01} className="img-fluid" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={about02} className="img-fluid" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={about03} className="img-fluid" alt="..." />
                        </div>
                    </div>
                    <div className="btn-slider">
                        <button className="carousel-control-prev about" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon about" aria-hidden="true"><i className="fas fa-arrow-left"></i></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next about" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
                            <span className="carousel-control-next-icon about" aria-hidden="true"><i className="fas fa-arrow-right"></i></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>  
            </div>
            <div className='col-md-6'>
                <h2 className="heading text-white"><span>Our Story:</span> Passion for Logistics & E-commerce Shipping</h2>
                <p className='text-white'>Created to make on-demand delivery possible, ParcelX is one of the fastest-growing end-to-end logistics aggregators. With deep domain expertise and automated solutions, we strive to become the best virtual logistics arm that offers seamless order fulfillment and shipping for our clients. Our platform supports your operations with trained personnel, speedy deliveries, timely pick-ups, and comprehensive return services. We are a one-stop solution to optimize your supply chain management and improve organisational efficiency.
                <br/><br/>
                We operate with trust, integrity, and a commitment to performance. We embrace teamwork while working safely. Our organisation values discipline, responsiveness, and punctuality to ensure optimal efficiency.</p>
            </div>
        </div>
    </div>
  )
}
